import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router';
import Layout from './components/Layout/Layout.tsx';
import { captureAttribution } from './lib/attribution.ts';

const Home = lazy(() => import('./routes/home/Home.tsx'));
const Browse = lazy(() => import('./routes/browse/Browse.tsx'));
const Video = lazy(() => import('./routes/video/Video.tsx'));
const Watch = lazy(() => import('./routes/watch/Watch.tsx'));
const Checkout = lazy(() => import('./routes/checkout/Checkout.tsx'));
const Subscribe = lazy(() => import('./routes/subscribe/Subscribe.tsx'));
const Account = lazy(() => import('./routes/account/Account.tsx'));
const ThankYou = lazy(() => import('./routes/thank-you/ThankYou.tsx'));
const Legal = lazy(() => import('./routes/legal/Legal.tsx'));
const NotFound = lazy(() => import('./routes/not-found/NotFound.tsx'));

function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      Loading…
    </div>
  );
}

export default function App() {
  useEffect(() => { captureAttribution(); }, []);

  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        {/* Immersive full-screen pages — no app shell */}
        <Route path="/watch/:slug" element={<Watch />} />
        <Route path="/checkout" element={<Checkout />} />

        {/* Home has its own full-page hero nav — no Layout shell */}
        <Route path="/" element={<Home />} />

        <Route element={<Layout />}>
          <Route path="/browse" element={<Browse />} />
          <Route path="/video/:slug" element={<Video />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/account" element={<Account />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/legal/:page" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
